import React from 'react';
import {GameStepScreenProps, puzzleComponentMapping, puzzleOrder} from "./type";

function Task2({state, update}: GameStepScreenProps) {
    const puzzle = puzzleOrder[state.teamIndex][2];

    const Comp = puzzleComponentMapping[puzzle];

    return <Comp state={state} update={(state) => update({
        ...state,
        step: 'FINISH',
    })} />;
}

export default Task2;
